<script setup lang="ts">
import { formatDateTime, getRelativeTime, getParam, convertServerDateToLocalDate, isToday } from '@/lib/utils';
import { useRoute } from 'vue-router';
import { Pencil, Plus } from 'lucide-vue-next';
import PatientDrawer from '@/components/profile/PatientsDrawer.vue';
import { Button } from '@/components/ui/button';

const route = useRoute();

defineProps({
    appointment: {
        type: Object,
        required: true
    }
});
</script>

<template>
    <div>
        <div class="bg-white rounded-xl border border-gray-300">
            <div class="p-5">
                <div>
                    <div class="font-bold text-2xl">{{ formatDateTime(appointment.appointmentDateTime) }}</div>
                    <div v-if="isToday(convertServerDateToLocalDate(appointment.appointmentDateTime))" class="mt-2 text-gray-600">({{ getRelativeTime(convertServerDateToLocalDate(appointment.appointmentDateTime)) }})</div>
                </div>
                <div class="flex items-center gap-2.5 mt-5">
                    <img :src="appointment.doctorImage || '/default.webp'" :alt="appointment.doctorName" class="size-7 rounded-full border-[1.5px] border-gray-900">
                    <div class="text-gray-900 font-semibold text-md">{{ appointment.doctorName }}</div>
                </div>
            </div>
            <RouterLink 
                :to="{name: 'manage_appointment', query: {appID: appointment.appID}, params: { domain: getParam(route) }}"
                class="border-t border-gray-300 py-3 px-4 flex justify-center items-center font-semibold text-sm"
            >
                <Pencil class="size-4 mr-2" />
                <span class="text-secondary">Modify Appointment</span>
            </RouterLink>
        </div>
        <PatientDrawer>
            <Button variant="outline" size="lg" class="w-full mt-3 border-gray-300 px-4 !justify-start active:scale-95 transition-all duration-100">
                <Plus class="size-5 mr-2" />
                <span class="font-semibold">Book a New Appointment</span>
            </Button>
        </PatientDrawer>
    </div>
</template>
